import { WifiOff } from "lucide-react";
import { useEffect, useState } from "react";

export function OfflineNotice() {
  const [online, setOnline] = useState(navigator.onLine);
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); };
  }, []);
  if (online) return null;
  return <div className="offline-banner" role="status"><WifiOff aria-hidden="true" /> Precisamos de internet. Sua resposta não será perdida enquanto esta tela estiver aberta.</div>;
}
